import PolicyDuration from 'components/@forms/PolicyDuration'
import Modal from '../@common/Modal'
import React from 'react'
import { useScheme, useVehicle, useDuration, useRiskData } from 'hooks'
import { DurationType } from 'types/global'
import { trackAmplitudeEvent } from 'utils/analytics-helpers'

interface Props {
  isVisible: boolean
  hideModal: () => void
  handleUpdate: (duration: number | null, durationType: DurationType) => void
}

const PolicyDurationModal: React.FC<Props> = ({
  isVisible,
  hideModal,
  handleUpdate,
}) => {
  const { scheme } = useScheme()
  const { vehicleType } = useVehicle()
  const { riskData } = useRiskData()

  const onSubmit = (duration: number | null, durationType: DurationType) => {
    trackAmplitudeEvent('quote_details_changed', {
      quote_id: riskData.QuoteId,
      product_type: vehicleType,
      scheme: scheme,
      duration: duration,
      duration_type: durationType,
    })
    handleUpdate(duration, durationType)
    hideModal()
  }

  return (
    <Modal
      id='policyDurationModal'
      isVisible={isVisible}
      onClose={hideModal}
      header='Cover for how long?'
      headerAlignment='center'
      fullscreen={window.innerWidth <= 500}
    >
      <PolicyDuration
        onSubmit={(duration, durationType) => onSubmit(duration, durationType)}
      />
    </Modal>
  )
}

export default PolicyDurationModal
